import { createSelector } from '@reduxjs/toolkit';
import { ProjectState } from 'ducks/project/slices';
import { RootState } from 'store';

const projectSlice = (state: RootState) => state.project;

export const selectProject = createSelector([projectSlice], (state): ProjectState => state);
export const selectProjectId = createSelector([projectSlice], (state): ProjectState['project_id'] => state.project_id);
